export const tradeRequestsRoute = { label: 'Trade Requests', path: 'trade-requests' };
